import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject ,  Subject } from 'rxjs';
import { HttpClientHelperService } from '../core/http-client-helper.service';
import { CitGlobalConstantService } from '../core/cit-global-constants.service'


@Injectable()
export class CitHelpService {

  constructor(
    private httpClient: HttpClientHelperService,
    private citGlobalConstants: CitGlobalConstantService

  ) {
   
  }


  public getDataForHelpUrl(url) {
    return this.httpClient.getRequest(url);
  }
}
